import { MonthNumber, MonthString } from './types';

export const ORDERED_MONTHS = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
] as const;

// FIXME: I didn't success in inferring the type from the expression, so I forced it
export const ORDERED_MONTHS_NUMBERS = Object.fromEntries(
    ORDERED_MONTHS.map((month: MonthString, index: number) => [
        month,
        index + 1,
    ]),
) as Record<MonthString, MonthNumber>;

// NOTE: this enum must synced with backend's vision/migrations/translation.py wage_type_pay_components
export enum PayComponent {
    BRUT = 'Brut',
    ASTREINTES = 'Astreintes',
    TBI = 'TBI',
    CTI = 'CTI',
    SFT = 'SFT',
    NBI = 'NBI',
    IFSE_AND_MONTHLY_PRIMES = 'IFSE et primes mensuelles',
    PONCTUAL_PRIMES = 'Primes ponctuelles (CIA / 13e mois / autre)',
    SUPPLEMENTARY_HOURS = 'Heures supplémentaires',
    COMPLEMENTARY_HOURS = 'Heures complémentaires',
    RESIDENCY_INDEMNITIES = 'Indemnités de résidence',
    EMPLOYER_COSTS = 'Charges patronales',
    OTHER = 'Autre',
}

export const ORDERED_PAY_COMPONENT = [
    PayComponent.BRUT,
    PayComponent.EMPLOYER_COSTS,
    PayComponent.TBI,
    PayComponent.NBI,
    PayComponent.RESIDENCY_INDEMNITIES,
    PayComponent.SFT,
    PayComponent.CTI,
    PayComponent.SUPPLEMENTARY_HOURS,
    PayComponent.COMPLEMENTARY_HOURS,
    PayComponent.ASTREINTES,
    PayComponent.IFSE_AND_MONTHLY_PRIMES,
    PayComponent.PONCTUAL_PRIMES,
    PayComponent.OTHER,
];
